import axios from 'axios';
import * as url from "../config/BackendConfig";


class CompetitionService {

    getCoveredLeagues = (lang='en') => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'portal',
                'Authorization': null,
                'Content-Type': "application/json",
            },
        };

        const requestUrl = url.BACKEND_BASE_URL + url.COVERED_LEAGUES;
        return axios.get(requestUrl, config);
    };


    getFavouriteLeagues = (token, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.FAVOURITE_LEAGUES;
        return axios.get(reuquestUrl, config);
    };


    setFavourite = (token, competitionId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.FAVOURITE_LEAGUES;
        return axios.post(reuquestUrl, { competitionId: competitionId, isFavourite: true }, config);
    };


    getFixtureDetails = (token, fixtureId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.FIZTURE_DETAILS + fixtureId + '/';
        return axios.get(reuquestUrl, config);
    };


    removeFavourite = (token, competitionId, lang) => {
        const tokenHeader = "Bearer " + token;
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Content-Type': "application/json",
                'Authorization': tokenHeader
            },
        };

        const reuquestUrl = url.BACKEND_BASE_URL + url.FAVOURITE_LEAGUES;
        return axios.post(reuquestUrl, { competitionId: competitionId, isFavourite: false }, config);
    };

}

const CompetitionServiceInstance = new CompetitionService();
export default CompetitionServiceInstance;